import classNames from "classnames";
import styles from "./card.module.less";

export default function Card({ item, reverse }) {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.reverse]: reverse,
      })}
    >
      <div className={styles.list}>
        <div
          className={styles.header}
          dangerouslySetInnerHTML={{ __html: item.title }}
        ></div>
        {item.moreBtn && (
          <a
            href={item.moreBtnLink}
            target="_blank"
            className={styles.moreBtn}
            data-gd-click="button_click"
            data-button-name={item.moreBtn}
          >
            {item.moreBtn}
          </a>
        )}
        {item.list.map((info, index) => {
          return (
            <div key={index} className={classNames(styles.item)}>
              <div className={styles.title}>{info.title}</div>
              <div className={styles.desc}>{info.desc}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.preview}>
        <img src={item.img?.[0].url} alt=""></img>
      </div>
    </div>
  );
}
